if (!customElements.get('product-finder')) {
  class ProductFinder extends HTMLElement {
    constructor() {
      super();
      this.flavorDisplayEl = this.querySelector('[data-display="flavor"]');    
      this.currentFlavor = this.flavorDisplayEl.innerHTML;
    }
    
    connectedCallback() {
      this.addEventListener('mouseover', e => {
        const enteredElement = e.target.closest('[data-hover-title]');
        
        if (!enteredElement) return;
        
        this.flavorDisplayEl.innerHTML = enteredElement.dataset.hoverTitle;
        enteredElement.addEventListener('mouseleave', () => {
          this.flavorDisplayEl.innerHTML = this.currentFlavor;
        }, { once: true });
        
      });

      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-action="select-thumb"]');
        const index  = clickedElement.dataset.index;
        if (!clickedElement) return;

        this.querySelectorAll('[data-action="select-thumb"].selected')
          .forEach((el) => {
            el.classList.remove('selected');
          });
        clickedElement.classList.add('selected');
        
        this.querySelector('[data-product-images="main"]')?.prepend(this.querySelector(`[data-product-images="main"] > [data-index="${index}"]`));

      });
      
      this.addEventListener('change', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        const {
          action,
          flavor,
          productHandle,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'product-select':

              this.flavorDisplayEl.innerHTML = flavor;
              this.currentFlavor = flavor;
              document.querySelectorAll('[data-section]').forEach((sectionWrapper) => {
              const sectionId = sectionWrapper.dataset.section;
              const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
              const sectionInnerHTML = sectionWrapper.innerHTML;
              sectionWrapper.innerHTML = `
                <intersection-loader 
                  data-url="/products/${productHandle}"
                  data-section-id="${sectionId}"
                  class="${sectionWrapper.classList}"
                >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
              `;
            });
          break;
          case 'select-thumb':
            alert()
            this.querySelectorAll('[data-action="select-thumb"].selected')
              .forEach((el) => {
                el.classList.remove('selected');
              });
            clickedElement.classList.add('selected');
            
            this.querySelector('[data-product-images="main"]')
              ?.prepend(this.querySelector(`[data-product-images="main"] > [data-index="${index}"]`));
          break;
          default:
          break;
        }
      });
    }
  }
  
  customElements.define('product-finder', ProductFinder);
}